import React from 'react';
import RadialProgress from 'react-radial-progress';
import is from 'is_js';
import PropTypes from 'prop-types';
import bandColors from '../ScoreBand/hfv4BandColors.postcss';
import { getHfv4BandForScore } from '../ScoreBand/hfv4ScoreBands';

const RadialScoreDisplay = (props) => {
  const value = is.number(props.percent) ? props.percent : props.value;
  let color = bandColors.colorDefault;
  if (is.number(props.percent) || props.unit === 'percent') {
    const band = getHfv4BandForScore(value);
    if (band) color = band.color;
  }
  return <div className={props.className}>
    <RadialProgress {...props}
        progressStroke={color}
        value={props.percent || props.value} />
  </div>;
};

RadialScoreDisplay.propTypes = {
  unit: PropTypes.string,
  value: PropTypes.number,
  percent: PropTypes.number,
  className: PropTypes.string,
};

export default RadialScoreDisplay;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/RadialScoreDisplay/index.jsx